import { useState } from "react";

export interface FilterOption {
  label: string;
  value: string;
}

export interface FilterGroup {
  key: string;
  label: string;
  options: FilterOption[];
}

interface FilterPanelProps {
  groups: FilterGroup[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
  onReset: () => void;
  hasActiveFilter: boolean;
}

export default function FilterPanel({
  groups,
  values,
  onChange,
  onReset,
  hasActiveFilter,
}: FilterPanelProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between md:hidden">
        <span className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-filter-3-line text-primary-600"></i>
          筛选条件
        </span>
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className="flex items-center gap-1 text-sm text-primary-600"
        >
          {expanded ? "收起" : "展开"}
          <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
        </button>
      </div>

      <div className={`${expanded ? "block" : "hidden"} md:block`}>
        <div className="space-y-4 pt-4 md:pt-0">
          {groups.map((group) => (
            <div key={group.key} className="flex flex-col gap-2 md:flex-row md:items-start md:gap-4">
              <span className="shrink-0 pt-1 text-sm font-medium text-foreground-500 md:w-16">
                {group.label}
              </span>
              <div className="flex flex-wrap gap-2">
                <button
                  type="button"
                  onClick={() => onChange(group.key, "")}
                  className={`rounded-md px-3 py-1 text-xs font-medium transition-colors ${
                    !values[group.key]
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  全部
                </button>
                {group.options.map((option) => (
                  <button
                    key={option.value}
                    type="button"
                    onClick={() => onChange(group.key, option.value)}
                    className={`rounded-md px-3 py-1 text-xs font-medium transition-colors ${
                      values[group.key] === option.value
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-600 hover:bg-background-200"
                    }`}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        {hasActiveFilter && (
          <div className="mt-4 border-t border-background-200 pt-4">
            <button
              type="button"
              onClick={onReset}
              className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-semibold text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              <i className="ri-refresh-line"></i>
              重置全部筛选
            </button>
          </div>
        )}
      </div>
    </div>
  );
}